<app-topnav></app-topnav>

<div class="page-heading-banner contact-us-color">
    <div class="container">
        <div class="contact-us-content">    
            <h1>{{'contactusText'|translate:translation}}</h1>
            <span>{{'gotQuestionsText'|translate:translation}}</span>
        </div>
    </div>
</div>
<div class="h-30"></div>
<div class="container">
    <div class="content">
        
        <div class="contact-form col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
            <p class="lead">{{"messageWillBeSentToTeamMemberText"|translate:translation}}</p>
        <div class="form-group">
            <label for="name">{{'yourNameText'|translate:translation}}</label>
            <input type="text" name="name" [(ngModel)]="contactusModel.name" class="form-control">
          </div>
          <div class="form-group">
            <label for="email">{{'yourEmailText'|translate:translation}}</label>
            <input type="text" name="email" [(ngModel)]="contactusModel.email" class="form-control" required="">
          </div>
          <div class="form-group">
            <label for="message">{{'yourMessageText'|translate:translation}}</label>
            <textarea name="message" [(ngModel)]="contactusModel.message" class="form-control"></textarea>
          </div>
          <div class="form-group">
          <input type="submit" class="btn btn-sm video-store-login-button" value="Send" (click)="onSubmit()">
          </div>
       
      </div>
    </div>
</div>
<app-footer></app-footer>